<template>
    <div 
        class="d-flex align-items-center justify-content-center"
        style="height: 100vh;"
    >
        <template v-if="passwordUpdated">
            <div
                class="card border-light" 
                style="width: 18rem; margin: 40px auto 0;"
            >
                <div class="card-body text-center">
                    <b-icon icon="check-circle-fill" variant="success" font-scale="7.5" class="mb-2"></b-icon>
                    <h5 class="card-title">{{ $t("done") }}</h5>
                    <p class="card-text">
                        {{ $t('password-updated') }}
                    </p>
                    <button
                        class="btn btn-primary mt-2"
                        @click="goToLogin()"
                    >
                        {{$t('login')}}
                    </button>
                </div>
            </div>
        </template>
        <template v-else>
            <div
                class="card border-light" 
                style="width: 18rem;"
            >
                <div class="card-body text-center">
                    <h5 class="card-title">{{ $t("change-password") }}</h5>
                    <b-alert
                        v-if=error 
                        variant="danger"
                        show
                    >
                        {{error}}
                    </b-alert>
                    <input
                        id="password1"
                        v-model="newPassword"
                        type="password"
                        :placeholder="$t('new-password')"
                        :aria-label="$t('new-password')"
                        autocomplete="new-password"
                        autocorrect="off"
                        autocapitalize="off"
                        class="form-control"
                    />
                    <input
                        id="password2"
                        v-model="confirmNewPassword"
                        type="password"
                        :placeholder="$t('confirm-new-password')"
                        :aria-label="$t('confirm-new-password')"
                        autocomplete="confirm-new-password"
                        autocorrect="off"
                        autocapitalize="off"
                        class="form-control mt-2"
                    />
                    <button
                        class="btn btn-primary btn-login mt-2"
                        @click="setPassword()"
                        :disabled="newPassword !== confirmNewPassword || newPassword.length < 6"
                    >
                        {{$t('update')}}
                    </button>
                </div>
            </div>
        </template>
       

    </div>
</template>
<script>
export default {
	components: {
     
	},
    data() {
        return {
            passwordUpdated: false,
            newPassword: '',
            confirmNewPassword: '',
            appurl:null,
            error:null
        }
    },
    mounted(){
    },
    methods: {
        setPassword() {
			this.$cfetch(`${this.$settings.APIBaseURL}/users/passwordreset/default`, {
				method: "post",
				data: {
                    pass1: this.newPassword,
                    pass2: this.confirmNewPassword,
                    t: this.$route.params.token
                },
			}).then((res) => {
                if (res.status !== "SUCCESS") {
                    this.error = res.errorMessage;
                    throw new Error('Something went wrong');
                }
                    
                this.passwordUpdated = true;
                this.appurl = res.appurl

            })
            .catch((error) => {
                this.$log.error.call(this, error);
            });
		},
        goToLogin(){
            window.location.href = this.appurl
        }
    }
} 
</script>